import React, { useState } from 'react';
import './ContactModal.css';

const ContactModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    parentName: '',
    grade: '',
    board: '',
    school: '',
    location: '',
    comments: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `*New Enquiry - Tesla's Academy*

*Student Name:* ${formData.name}
*Parent Name:* ${formData.parentName}
*Grade:* ${formData.grade}
*Board:* ${formData.board}
*School:* ${formData.school}
*Location:* ${formData.location}
*Comments:* ${formData.comments}

Thank you for your interest in Tesla's Academy!`;

    const phoneNumber = '919626137666'; // Replace with your WhatsApp number
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, '_blank');
    onClose();
    setFormData({
      name: '',
      parentName: '',
      grade: '',
      board: '',
      school: '',
      location: '',
      comments: ''
    });
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h2 className="modal-title">Enroll at Tesla's Academy</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Student Name *</label>
            <input
              type="text"
              name="name"
              className="form-input"
              value={formData.name}
              onChange={handleInputChange}
              required
              placeholder="Enter student's full name"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Parent Name *</label>
            <input
              type="text"
              name="parentName"
              className="form-input"
              value={formData.parentName}
              onChange={handleInputChange}
              required
              placeholder="Enter parent's name"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Grade *</label>
            <select
              name="grade"
              className="form-select"
              value={formData.grade}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Grade</option>
              {[...Array(12)].map((_, i) => (
                <option key={i} value={`Grade ${i + 1}`}>Grade {i + 1}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Board *</label>
            <select
              name="board"
              className="form-select"
              value={formData.board}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Board</option>
              <option value="CBSE">CBSE</option>
              <option value="Matric">Matric</option>
              <option value="IGCSE">IGCSE</option>
              <option value="ICSE">ICSE</option>
              <option value="IB">IB</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">School Name *</label>
            <input
              type="text"
              name="school"
              className="form-input"
              value={formData.school}
              onChange={handleInputChange}
              required
              placeholder="Enter school name"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Location *</label>
            <select
              name="location"
              className="form-select"
              value={formData.location}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Preferred Branch</option>
              <option value="Tirupur - Main Branch">Tirupur - Main Branch</option>
              <option value="Tirupur - Branch 2">Tirupur - Branch 2</option>
              <option value="Coimbatore - RS Puram">Coimbatore - RS Puram</option>
              <option value="Coimbatore - Saibaba Colony">Coimbatore - Saibaba Colony</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Comments</label>
            <textarea
              name="comments"
              className="form-textarea"
              value={formData.comments}
              onChange={handleInputChange}
              placeholder="Any specific requirements or questions..."
            />
          </div>
          <button type="submit" className="submit-button">
            Submit Enquiry via WhatsApp
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
